import * as React from "react"
import { Box } from "@mui/material"
import { ButtonIconSeeker } from "@ui-seeker/core"

import { useForm } from "../../@hooks"
import { isOpen, rowSelected, reportIDSelected, historicalDataRowClick, openDetails } from "../../@signals"
import {REPORT_TYPES} from "../../@constants";


export default function optionsColumn() {
	return {
		name: '', label: 'Options',
		options: {
			filter: false,
            setCellProps: () => ({ sx: { textAlign: "center", maxWidth: 50 } }),
			customBodyRowRenderLite: (value, row) => <OptionsCell row={row} />
		}
	}
}

const OptionsCell = ( {row} ) => {

	const { setModalData, deleteRow } = useForm()

	const handleUpdateClick = () => {
		setModalData(row)
		rowSelected.value = row
		isOpen.value = true
	}

	const handleDeleteClick = () => {
		reportIDSelected.value = row.reportID
		deleteRow(row)
	}

	const handleHistoricalClick = (row) => {
		historicalDataRowClick.value = row
        openDetails.value = true
	}

	const isFlashOfferReport = row.reportTypeKey === REPORT_TYPES.FLASH_OFFERS

	return <Box sx={{ display: 'flex' }} >
		<ButtonIconSeeker icon="circle-info" tooltip="View Historical Execution"  onClick={() => handleHistoricalClick(row)} />
		{!isFlashOfferReport && <ButtonIconSeeker icon="pen" tooltip="Update Report"  onClick={handleUpdateClick} />}
		<ButtonIconSeeker icon="trash" tooltip="Delete Report"  onClick={handleDeleteClick} />
    </Box>
}